import {Stack} from 'shells/layout/stack/stack';

import {ExplorePageSectionHeader} from './explore-page-section-header';
import {QuotesPromoBanner} from './quotes-promo/quotes-promo-banner';
import {useGetShowQuotesPromo} from './quotes-promo/use-get-show-quotes-promo';

export function CouponOffersSection() {
    const quotesPromo = useGetShowQuotesPromo();

    const hasAnyOffer = quotesPromo.shouldShow;

    return (
        <div className={hasAnyOffer ? undefined : 'display-none'}>
            <Stack spacing={16}>
                <ExplorePageSectionHeader title='Promotions' />
                <QuotesPromoBanner
                    shouldShow={quotesPromo.shouldShow}
                    isLoading={quotesPromo.isLoading}
                    refetchSetting={quotesPromo.refetchSetting}
                />
            </Stack>
        </div>
    );
}
